import { render } from "./OrderTimeLine.vue?vue&type=template&id=0083462e&scoped=true"
import script from "./OrderTimeLine.vue?vue&type=script&lang=js"
export * from "./OrderTimeLine.vue?vue&type=script&lang=js"

import "./OrderTimeLine.vue?vue&type=style&index=0&id=0083462e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0083462e"]])

export default __exports__